import { handleAxiosErrors } from '../helpers/errors';

import envConfig from './env-config';

const YoutubeApi = {
    getVideoDetails: async (embedId: string) => {
        try {
            const response = await fetch(
                `https://www.googleapis.com/youtube/v3/videos?id=${embedId}&key=${envConfig.YOUTUBE_API_KEY}&part=contentDetails`,
            );
            return response.json();
        } catch (err) {
            handleAxiosErrors(err);
        }
    },
};

export default YoutubeApi;
